import React from "react";
import EditIcon from "../assets/icons/edit-icon.svg";
import DeleteIcon from "../assets/icons/delete-icon.svg";
import "../styles/components/social_activity_item.css";

const SocialActivityItem = ({ activity, index, onEdit, onDelete }) => {
    return (
        <div className="social-activity-item">
            <h3 className="social-activity-item-title">
                {index + 1}. {activity}
            </h3>
            <div className="social-activity-item-actions">
                <button
                    type="button"
                    className="social-activity-item-btn social-activity-item-edit"
                    onClick={() => onEdit(index)}
                >
                    <img src={EditIcon} alt="Edit" />
                </button>
                <button
                    type="button"
                    className="social-activity-item-btn social-activity-item-delete"
                    onClick={() => onDelete(index)}
                >
                    <img src={DeleteIcon} alt="Delete" />
                </button>
            </div>
        </div>
    );
};

export default SocialActivityItem;